module.exports = __webpack_public_path__ + "static/media/img_Inscription_name2@2x.8029cc68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_name2@2x.png
// module id = 993
// module chunks = 0